import Content from '../../pages/content'

export default {
  path: 'content',
  component: Content,
}



// WEBPACK FOOTER //
// ./src/routes/Content/index.js